module.exports = __webpack_public_path__ + "static/community-1-a6780fc17ba40b4d00ec7b9e4e25f6fa.png";